export const ResponsivenessConfiguration = {
  drawerWidth: 260,
  permanentSidebarBreakPoint: 'lg' as const,
};
